module.exports = __webpack_public_path__ + "img/2_003.50a0afde.webp";